import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';

const CommentLoader = () => {
  return (
    <div>
      <LineLoader
        containerStyle="mx-4 mb-6"
        numberOfLines={1}
        childrenType="H5"
        dimenshionUnit="px"
        lineStyle="!h-4 w-[100px]"
      />
      <LineLoader
        containerStyle="mx-4"
        numberOfLines={1}
        childrenType="H5"
        dimenshionUnit="px"
        lineStyle="!h-4 w-[150px]"
      />
      <LineLoader
        containerStyle="mx-4 mt-2"
        numberOfLines={1}
        childrenType="H4"
        dimenshionUnit="px"
        lineStyle="!h-4 w-[300px]"
      />
    </div>
  );
};

export default CommentLoader;
